// extracted by mini-css-extract-plugin
export var standaloneTable = "_dx-0";
export var standaloneTableWithBodyFill = "_dx-1";
export var withExtraHeader = "_dx-2";